import React, { lazy, Suspense, useEffect, useState } from "react";

import { FacebookOutlined, LinkedIn } from "@mui/icons-material";
import {
  Box,
  ButtonBase,
  CircularProgress,
  Divider,
  Typography,
} from "@mui/material";
import { connect } from "react-redux";

import { EmptyState, PostPreviewCard } from "../../common";
import { setActionButtonToggle as setActionButtonToggleAction } from "../../redux/slices/authSlice";
import { updatePostFormData as updatePostFormDataAction } from "../../redux/slices/postsSlice";
import PostContentEditModal from "../Modals/PostContentEditModal";
import { templates_data } from "../Templates/templates_data";
import CustomTemplates from "../Templates/CustomTemplates";

const Templates = lazy(() => import("../Templates"));

const CreatePostSelectTemplate = ({
  triggerValidation,
  company,
  setActionButtonToggle,
  setTriggerValidation,
  onNext,
  post_form_data,
  updatePostFormData,
}) => {
  const isThemeSelected = company?.color_theme?.primary;
  const [selected, setSelected] = useState(templates_data[0]);
  const [content, setContent] = useState(post_form_data?.job_description || "");
  const [editPostContentModal, setEditPostContentModal] = useState(false);
  const [preview] = useState("Linkedin");

  const _toggleEditPostContentModal = () =>
    setEditPostContentModal((prev) => !prev);

  useEffect(() => {
    const handleNext = () => {
      if (!isThemeSelected) return setActionButtonToggle(true);
      if (triggerValidation && post_form_data?.job_description && selected) {
        onNext();
        updatePostFormData({
          job_description: content,
          company_personalised_template_url: selected,
        });
        return;
      }
      setTriggerValidation(false);
    };
    handleNext();
  }, [triggerValidation]);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        bgcolor: "#ffff",
        height: { xs: "auto", md: "100%" },
      }}
    >
      {/* Template Section */}
      <Box width={{ xs: "100%", lg: "75%" }}>
        <Box px={3} pt={2} width="100%">
          <Typography fontWeight={500} fontSize="1.2rem">
            Create a post
          </Typography>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            my={2}
            gap={2}
          >
            <Typography fontSize="1rem" fontWeight={500} color="#464646">
              Select Template
            </Typography>
          </Box>
        </Box>
        <Divider sx={{ my: 1 }} />
        <Box
          sx={{
            height: { xs: "auto", md: "85%" },
            overflow: "auto",
            p: 3,
          }}
        >
          {isThemeSelected && (
            <Suspense
              fallback={
                <Box width="600px" height="600px" className="center">
                  <CircularProgress
                    size={24}
                    sx={{
                      display: "block",
                      margin: "auto",
                      color: "#1B9CCA",
                    }}
                  />
                </Box>
              }
            >
                <CustomTemplates
                  selected={selected}
                  setSelected={setSelected}
                />
              <Templates selected={selected} setSelected={setSelected} />
            </Suspense>
          )}

          {!isThemeSelected && (
            <Box
              sx={{
                width: "100%",
                height: "500px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 4,
              }}
            >
              <EmptyState
                title="Looks like you haven't added your company theme!. Please configure your company theme so we can show you some cool templates"
                top={"20%"}
              />
            </Box>
          )}
        </Box>
      </Box>

      {/* Preview Right Box */}
      <Box
        display={{ xs: "none", lg: "initial" }}
        borderLeft="1px solid #E8EAED"
        bgcolor="#f9f9f9"
        overflow="auto"
        flex={{ xs: 0.5, lg: 1.5 }}
      >
        <Box p={2} borderBottom="1px solid #E8EAED" bgcolor="white">
          <Typography fontWeight={500} fontSize="1.2rem">
            Previews
          </Typography>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          px={2}
          pt={2}
          pb={1}
          gap={1}
        >
          <Box
            sx={{
              flex: 1,
              p: "3px", // padding equal to the border size
              border: preview === "Linkedin" ? "2px solid #4BC7E1" : "none",
              borderRadius: "38px", // outer radius = inner radius + padding
              // backgroundColor: preview === "Linkedin" ? "#4BC7E1" : "transparent",
            }}
          >
            <ButtonBase
              sx={{
                bgcolor: "#0077B5",
                py: ".5rem",
                px: 0.5,
                width: "100%",
                gap: 1,
                alignItems: "center",
                borderRadius: "35px",
                cursor: "default",
              }}
            >
              <LinkedIn sx={{ color: "white" }} />
              <Typography color="white" fontSize=".8rem" fontWeight={600}>
                Linkedin
              </Typography>
            </ButtonBase>
          </Box>

          <ButtonBase
            sx={{
              flex: 1,
              border:
                preview === "Facebook"
                  ? "3px solid #4BC7E1"
                  : "3px solid transparent",
              bgcolor: "#DFDFDF",
              p: 0.5,
              width: "100%",
              alignItems: "center",
              gap: 1,
              borderRadius: "35px",
              opacity: 0.8,
            }}
            disabled
          >
            <FacebookOutlined
              sx={{ width: "1.7rem", height: "1.7rem", color: "white" }}
            />
            <Typography color="white" fontSize=".8rem" fontWeight={600}>
              Facebook
            </Typography>
          </ButtonBase>
        </Box>
        <PostPreviewCard
          template={selected}
          company={company}
          hfull
          showEditBtn
          onEditClick={_toggleEditPostContentModal}
          postContent={content}
        />
        <PostContentEditModal
          open={editPostContentModal}
          template={selected}
          company={company}
          postContent={content}
          onEditContent={(newContent) => setContent(newContent)}
          onClose={_toggleEditPostContentModal}
        />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  company: state.company.company,
  post_form_data: state.posts.post_form_data,
});

const mapDispatchToProps = {
  // createPostContent: createPostContentAction,
  // getTemplates: getTemplatesAction,
  setActionButtonToggle: setActionButtonToggleAction,
  updatePostFormData: updatePostFormDataAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreatePostSelectTemplate);
